import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { startOfMonth, endOfMonth, setMonth, isValid, addDays } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Facility } from '../../../interfaces/facility';
import { Records } from '../../../interfaces/records';
import { Stores } from '../../../interfaces/stores';

@Component({
  selector: 'app-list-controls-facility',
  templateUrl: './list-controls-facility.component.html',
  styleUrls: ['./list-controls-facility.component.css']
})
export class ListControlsFacilityComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private helps: Helps,
    private modal: NgbModal,
    private dateAdapter: DateAdapter<Date>

  ) { }

  @Input()
  facilityId:number;

  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.dateAdapter.setLocale('es'); // Establece el idioma de las fechas a español
    this.mesActual = new Date();
    this.getData();
    if(this.facilityId>0){
      this.get(); 
    }
   
  }

  items: Records[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  facilityes:Facility[];
  stores:Stores[];
  loading: boolean = false;
  pathDownload: string = null;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
    facility_id: new UntypedFormControl(0),
    stores_id: new UntypedFormControl(0),
    q:new UntypedFormControl('')
  });

  clean(){
    this.form.get('q').setValue('');
    this.page=1;
    this.get();
  }
  search(q:string='') {
    if(q.length>=2){
      this.form.get('q').setValue(q);
      console.log('result q:',q);
      this.page=1;
    }
    this.get();
  }

  setDaysStartEnd() {
      this.inicioMes = startOfMonth(this.mesActual);
      this.finMes = endOfMonth(this.mesActual);
    this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
    this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
    this.page=1;
    this.get();
  }
  setRangeCalendar() {
    if (isValid(this.form.get('start')?.value) && isValid(this.form.get('end')?.value)) {
      this.inicioMes = addDays(new Date(this.form.get('start')?.value), 1);
      this.finMes = addDays(new Date(this.form.get('end')?.value), 1);
      this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
      this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
      this.get();
    }
  }
  get() {
    this.form.get('facility_id')?.setValue(this.facilityId);
    this.api.paginateRecordsFacility(this.page, this.form,1).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Records[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
      }
    );
  }
  getData() {
    this.api.getAllStores().subscribe(
      (response) => {
        this.stores = response.data as Stores[];
      }
    );
  }

  mesView: string;
  mesActual: Date;
  fechas: Date[];
  //dia inicial del mes
  inicioMes: Date;

  //dia final del mes
  finMes: Date;
  setStartDay(event: any) {
    this.form.get('start')?.setValue(event.value);
  }

  cambiarMes(delta: number): void {
    this.mesActual = setMonth(this.mesActual, this.mesActual.getMonth() + delta);
    this.mesView = this.mesActual.toISOString();
    this.setDaysStartEnd();
  
  }

  obtenerNombreMes(mes: number): string {
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    return nombresMeses[mes];
  }
  openModal(mdl: any) {
    this.modal.open(mdl);
  }

  generateReport(mdl:any) {
    this.modal.open(mdl);
    // Simular un proceso de generación de reporte
    this.loading = true;
    this.api.generateReport(this.form,1).subscribe(
      (rs) => {
        console.log("REPORT SUCCESS:", rs);
        this.loading = false;
        this.toast.success(rs.msg);
        let result = rs as any;
        this.pathDownload = result?.path;
      },
      e => {
        console.log("REPORT ERROR:", e);
        this.loading = false;
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }
}

